<template>
  <div :class="[{ 'd-flex': flex }, { 'gap-2': img }]">
    <h5 class="body-1">{{ label }}</h5>
    <h5
      class="body-1"
      :class="[text ? '' : 'text--secondary', { 'mr-2': flex }]"
    >
      <slot>
        <div v-if="img" class="image-input">
          <a
            :href="img"
            target="_blank"
            class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
            data-action="change"
            data-toggle="tooltip"
            title=""
            data-original-title="Change avatar"
          >
            <i class="fa fa-eye icon-sm text-muted"></i>
          </a>
          <img :src="img" alt="" class="img" />
        </div>
        <a
          class="blue--text"
          style="text-decoration: underline"
          target="_blank"
          v-else-if="link"
          :href="textData"
          >{{ textData || '(وارد نشده)' }}</a
        >
        <span v-else>{{ textData || '(وارد نشده)' }}</span>
      </slot>
    </h5>
  </div>
</template>

<script>
export default {
  props: {
    text: [String, Array],
    label: String,
    link: Boolean,
    img: String,
    flex: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    textData() {
      if (this.text == undefined) {
        return null;
      } else if (typeof this.text == 'string' || typeof this.text == 'number') {
        return this.text;
      }
      return this.text.join(',');
    },
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 2rem;
}
.img {
  width: 150px;
  border-radius: 5px;
}
.fix {
  position: absolute;
  top: 0;
}
</style>
